// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1VSUU","header":"ReportDetails_header__3QZg2","title":"ReportDetails_title__2iuwn","left":"ReportDetails_left__3BgUs"};